import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCoupleStyle0 = gravityIconIndividualCss;

const GravityIconCouple = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '61206aadc3a823c742271d8fee15d2dad10fb175', color: this.color, size: this.size }, h("svg", { key: 'a9074473f9432d73b6962a810c9ffd71e0dda3e4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c1b5a93bc46caa82864519d33d6cb0c25d602d68', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 5.5A.5.5 0 0 0 18 5v-.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h13ZM4.5 8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Zm1 1.5h3v3h-3v-3Zm7-1.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Zm1 1.5h3v3h-3v-3Zm4.5 8a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v.5Z", fill: "currentColor" }))));
    }
};
GravityIconCouple.style = GravityIconCoupleStyle0;

export { GravityIconCouple as gravity_icon_couple };

//# sourceMappingURL=gravity-icon-couple.entry.js.map